module.exports = __webpack_public_path__ + "static/media/psoriasis-skin-knee-icon.4bea9953.svg";